export const SIGNED_OUT_HOMEPAGE_TOP_DROPDOWN_OPTIONS = [
  { link: '/product/what-is-postman/', text: 'What is Postman?', type: 'text' },
  { link: '/product/api-repository/', text: 'API repository', type: 'text' },
  { link: '/product/tools/', text: 'Tools', type: 'text' },
  { link: '/product/intelligence/', text: 'Intelligence', type: 'text' },
  { link: '/product/workspaces/', text: 'Workspaces', type: 'text' },
  { link: '/product/integrations/', text: 'Integrations', type: 'text' },
  { link: '/downloads/', text: 'Get started free', type: 'link' }
];

export const SIGNED_OUT_HOMEPAGE_TOP_ENTERPRISE_DROPDOWN_OPTIONS = [
  { link: '/postman-enterprise/', text: 'Postman Enterprise' },
  { link: '/case-studies/', text: 'Enterprise case studies' },
  { link: '/company/contact-us/', text: 'Contact us' }
];

export const SIGNED_OUT_HOMEPAGE_TOP_LEARNING_DROPDOWN_OPTIONS = [
  { link: '/docs/getting-started/introduction/', text: 'Docs' },
  { link: '/webinars/', text: 'Webinars' },
  { link: '/events/breaking-changes/', text: 'Breaking Changes show' },
  { link: '/events/postman-space-camp/', text: 'Postman Space Camp' },
  { link: '/case-studies/', text: 'Case studies' }
];

export const SIGNED_OUT_HOMEPAGE_TOP_COMMUNITY_DROPDOWN_OPTIONS = [
  { link: 'https://blog.postman.com/', text: 'Blog' },
  { link: '/community/', text: 'Community' },
  { link: '/company/student-program/', text: 'Student program' },
  { link: '/company/student-program/student-summit/', text: 'Student Summit' },
  { link: '/postman-galaxy/', text: 'Postman Galaxy' },
  { link: '/company/nonprofit/', text: 'Postman for Nonprofits' },
  { link: 'https://store.getpostman.com/', text: 'Postman swag' }
];

export const SIGNED_OUT_HOMEPAGE_TOP_SUPPORT_DROPDOWN_OPTIONS = [
  { link: '/support/', text: 'Support Center' },
  { link: '/support/resellers-support/', text: 'Reseller support' },
  { link: 'https://status.postman.com/', text: 'Postman status' },
  { link: '/downloads/release-notes/', text: 'Release notes' }
];
